










































































































import {Component, Emit, Prop, PropSync, Vue} from "vue-property-decorator";
import {LadingStore} from "../../store";
import LadingTableAction from "./TableAction.vue";
import moment from 'moment';
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import {FORMAT_DATE_TIME_PICKER, PAGE_SIZE_OPTIONS} from "@/shared/constant";
import LadingTypeLabel from "@/modules/ladings/List/components/TypeLabel.vue";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";

@Component({
    name: "LadingTable",
    components: {TooltipLabel, LadingTypeLabel, LadingStatusLabel, LadingTableAction}
})
export default class extends mixins(CommonMixin) {
    @PropSync("selectedRowLadings", {type: Array, default: () => []}) syncSelectedRowLadings!: string[];
    @Prop({type: Boolean, default: false}) readonly isViewUpdate!: boolean;
    moment = moment;
    FORMAT_DATE_TIME_PICKER = FORMAT_DATE_TIME_PICKER;
    columns = [
        {
            title: "#",
            dataIndex: "rowGuid",
            key: "rowGuid",
            scopedSlots: {customRender: 'action'},
            fixed: 'left',
            width: 100
        },
        {
            title: "Ngày giờ tạo",
            dataIndex: "createdDate",
            key: "createdDate",
            width: 150,
            ellipsis: true
        },
        {
            title: "Mã đơn hàng",
            dataIndex: "ladingCode",
            key: "ladingCode",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: "ladingCode"}
        },
        // {
        //     title: "Vận đơn ĐT",
        //     dataIndex: "partnerLadingCode",
        //     key: "partnerLadingCode",
        //     width: 150,
        //     ellipsis: true,
        //     scopedSlots: {customRender: "partnerLadingCode"}
        //
        // },
        // {
        //     title: "Bưu cục nhận",
        //     dataIndex: "acceptancePostOffice.name",
        //     key: "acceptancePostOffice",
        //     width: 200,
        //     ellipsis: true,
        //     scopedSlots: {customRender: "acceptancePostOfficeName"}
        // },
        {
            title: "Đại diện gửi",
            dataIndex: "locationFrom.name",
            key: "locationFromId",
            width: 200,
            ellipsis: true,
            scopedSlots: {customRender: "locationFromName"}
    
        },
        // {
        //     title: "Mã khách hàng",
        //     dataIndex: "customer.customerCode",
        //     key: "customer",
        //     width: 150,
        //     ellipsis: true,
        //     scopedSlots: {customRender: "customerCode"}
        // },
        {
            title: "Tỉnh đến",
            dataIndex: "locationTo.province.name",
            key: "locationToId",
            width: 200,
            ellipsis: true,
            scopedSlots: {customRender: "provinceToName"}
        },
        {
            title: "Người nhận",
            dataIndex: "locationTo.name",
            key: "locationToName",
            width: 200,
            ellipsis: true,
            scopedSlots: {customRender: "locationToName"}
        },
        {
            title: "SDT Người nhận",
            dataIndex: "locationTo.phoneNumber",
            key: "locationToPhoneNumber",
            width: 120,
            ellipsis: true,
            scopedSlots: {customRender: "locationToPhoneNumber"}
        },
        {
            title: "Địa chỉ",
            dataIndex: "locationTo",
            key: "locationToAddress",
            scopedSlots: {customRender: "locationToAddress"},
            width: 500,
            ellipsis: true
        },
        {
            title: "Dịch vụ",
            dataIndex: "freightService",
            key: "freightService",
            width: 100,
            scopedSlots: {customRender: "freightService"},
            ellipsis: true
        },
        {
            title: "Thu hộ",
            dataIndex: "codMoney",
            key: "codMoney",
            scopedSlots: {customRender: "codMoney"},
            width: 150,
            ellipsis: true
        },
        {
            title: "Tổng cước",
            dataIndex: "totalFee",
            key: "totalFee",
            scopedSlots: {customRender: "totalFee"},
            width: 150,
            ellipsis: true
        },
        {
            title: "Thu tiền NN",
            dataIndex: "receiverCollect",
            key: "receiverCollect",
            scopedSlots: {customRender: "receiverCollect"},
            width: 150,
            ellipsis: true
        },
        {
            title: "Trả tiền KH",
            dataIndex: "senderPay",
            key: "senderPay",
            scopedSlots: {customRender: "senderPay"},
            width: 150,
            ellipsis: true
        },
        {
            title: "Trạng thái",
            dataIndex: "statusForCustomerTitle",
            key: "status",
            scopedSlots: {customRender: 'status'},
            width: 200,
            ellipsis: true
        },
        {
            title: "Thông tin báo phát",
            dataIndex: "rowGuid",
            key: "report",
            scopedSlots: {customRender: 'report'},
            width: 250,
            ellipsis: true
        }
    ];

    get ladings() {
        return LadingStore.ids.map((id: string) => LadingStore.data[id]);
    }

    get pagination() {
        return {
            current: LadingStore.meta.page,
            pageSize: LadingStore.meta.limit,
            total: LadingStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} vận đơn`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        if (this.isViewUpdate) {
            LadingStore.listLadingNeedUpdate({
                ...LadingStore.params,
                page: pagination.current,
                limit: pagination.pageSize
            });
        } else {
            LadingStore.listLading({...LadingStore.params, page: pagination.current, limit: pagination.pageSize});
        }
    }

    onSelectRowLadingChange(rowKeys: string[]) {
        this.syncSelectedRowLadings = rowKeys;
    }

    @Emit("updateLading")
    onUpdateLading(val) {
        return val;
    }
}
